// extracted by mini-css-extract-plugin
export default {"modalContent":"AccountApprovalModal_modalContent__aPNZs","infoText":"AccountApprovalModal_infoText__+JH3H","formGrid":"AccountApprovalModal_formGrid__85JS-"};